import { render } from "./Dot.vue?vue&type=template&id=4a227a0f&scoped=true"
import script from "./Dot.vue?vue&type=script&lang=js"
export * from "./Dot.vue?vue&type=script&lang=js"

import "./Dot.vue?vue&type=style&index=0&id=4a227a0f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a227a0f"

export default script